export const ADD_TOKEN = "ADD_TOKEN";
export const ADD_ID = "ADD_ID";


// WEBPACK FOOTER //
// ./src/constants/AppConstants.js